import { useRef, useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight, FaAngleDoubleLeft } from 'react-icons/fa';
import Product from './Product';

const GalleryDisplay = ({ type, products }) => {
  const galleryRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [canScroll, setCanScroll] = useState(false);

  useEffect(() => {
    const checkScrollButtons = () => {
      if (galleryRef.current) {
        const gallery = galleryRef.current;
        const isScrollable = gallery.scrollWidth > gallery.clientWidth;
        setCanScrollLeft(gallery.scrollLeft > 0);
        setCanScrollRight(gallery.scrollLeft < gallery.scrollWidth - gallery.clientWidth);
        setCanScroll(isScrollable);
      }
    };

    checkScrollButtons();
    const gallery = galleryRef.current;
    if (gallery) {
      gallery.addEventListener('scroll', checkScrollButtons);
    }

    return () => {
      if (gallery) {
        gallery.removeEventListener('scroll', checkScrollButtons);
      }
    };
  }, [products]);

  const scroll = (direction) => {
    const gallery = galleryRef.current;
    if (direction === 'right') {
      const scrollAmount = gallery.offsetWidth;
      gallery.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else if (direction === 'left') {
      const scrollAmount = -gallery.offsetWidth;
      gallery.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else if (direction === 'double-left') {
      gallery.scrollTo({ left: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="product-gallery__container">
        <div className='product-gallery__scrollable' ref={galleryRef}>
          <ul className="product-gallery__items">
            {products.map((product) => (
                <Product
                  type={type}
                  product={product}
              />
            ))}
          </ul>
        </div>
        {canScroll && canScrollLeft && (
          <button onClick={() => scroll('left')} className="scroll-button scroll-button--left">
            <FaChevronLeft className='scroll-button__icon scroll-button__icon--left' />
          </button>
        )}
        {canScroll && canScrollRight ? (
          <button onClick={() => scroll('right')} className="scroll-button scroll-button--right">
            <FaChevronRight className='scroll-button__icon scroll-button__icon--right' />
          </button>
        ) : canScroll && !canScrollRight && (
          <button onClick={() => scroll('double-left')} className="scroll-button scroll-button--double-left">
            <FaAngleDoubleLeft className='scroll-button__icon scroll-button__icon--double-left' />
          </button>
        )}
    </div>
  );
};

export default GalleryDisplay;
